import React from "react";
import { Container } from "react-bootstrap";

import GoBackButtonComponent from "../../../../public/goBackButton";

import {
  ReferralContainer,
  ReferralDetailTableBody,
  ReferralDetailTableHead,
} from "./styledUserReferralDetailComponent";

function UserReferralDetailComponent({ referralDetail }) {
  return (
    <ReferralContainer className="px-2">
      <GoBackButtonComponent />
      <Container className="p-0 referral-container mx-auto">
        <ReferralDetailTableHead>
          <div className={"col-3 d-inline-block text-center"}>ردیف</div>
          <div className={"col-3 d-inline-block text-center"}>
            نام و نام خانوادگی
          </div>
          <div className={"col-3 d-inline-block text-center"}>مبلغ دریافتی</div>
          <div className={"col-3 d-inline-block text-center"}>تاریخ</div>
        </ReferralDetailTableHead>
        {referralDetail?.map((item, index) => {
          return (
            <ReferralDetailTableBody key={item.id}>
              <div className={"col-3 d-inline-block text-center"}>
                {index + 1}
              </div>
              <div className={"col-3 d-inline-block text-center"}>
                {item?.invited?.first_name} {item?.invited?.last_name}
              </div>
              <div className={"col-3 d-inline-block text-center"}>
                {item?.total_income?.toLocaleString()}
              </div>
              <div className={"col-3 d-inline-block text-center"}>
                {item.created_at.split(" ")[0]}
              </div>
            </ReferralDetailTableBody>
          );
        })}
      </Container>
    </ReferralContainer>
  );
}

export default UserReferralDetailComponent;
